import {
    Box,
    Center,
    Container,
    Group,
    Image,
    Paper,
    Stack,
    Text,
    Title,
} from '@mantine/core';

import classes from "./HomePageMarketing.module.css";
import {CallToActionComponent} from "../CallToActionComponent.tsx";
import {AiOutlineArrowRight} from "react-icons/ai";
import {
    FlexiButton,
    FlexiSignInButton
} from "@flexinet/ui-components";
import {useNavigate} from "react-router-dom";
import config from "../../../../config";
import {signInWithRedirect} from "aws-amplify/auth";

export const HomePageMarketing = () => {

    const navigate = useNavigate()

    return (
        <Container className={classes.wrapper}>

            <Box className={classes.logo}>
                <Image
                    src={'600x200_logo.png'}
                    alt={config.appTitle}
                    onClick={() => navigate('/')}
                />
            </Box>

            <Box className={classes.inner}>


                <Title className={classes.title}>
                    Manage your{' '}
                    <Text
                        component="span"
                        c={'blue'}
                    >
                        domain names portfolio
                    </Text>{' '}
                    across registrars
                </Title>

                <Text className={classes.description}>
                    Track registrations, renewals, cost, contacts and reminders
                </Text>

                <Paper shadow="xl" m={'xl'} p="xl" withBorder>
                    <Stack justify={'center'} gap={'xl'}>
                        <Center mt={'xl'}>
                            <Title>As low as 50 &#162; domain name / month</Title>
                        </Center>

                        <Center mt={'xl'}>
                            <FlexiButton variant={'outline'} onClick={() => navigate('/pricing')}>
                                <Group>
                                    pricing details
                                    <AiOutlineArrowRight color={'var(--mantine-color-blue)'}/>
                                </Group>
                            </FlexiButton>
                        </Center>
                    </Stack>
                </Paper>

                <Center>
                    <CallToActionComponent/>
                </Center>

                <Center my={'xl'}>
                    <Stack>
                        <Text>Already have an account?</Text>
                        <FlexiSignInButton onClick={
                            () => {
                                signInWithRedirect()
                            }
                        }>Sign In</FlexiSignInButton>
                    </Stack>
                </Center>

            </Box>
        </Container>
    );
};
